const { Dashboard } = require('@mui/icons-material');
const { Construction } = require('lucide-react');

module.exports = {
  base: {
    useUrl: process.env.REACT_APP_USE_URL,
    // indexedDb: {
    //   name: 'blunex-administrator-indexed-db',
    // },
  },
  file: {
    useUrl: process.env.REACT_APP_FILE_URL,
  },
  urls: {
    /* 로그인 */
    Account: {
      login: 'api/Account/GetToken', // 로그인
      GetInfo: 'api/Account/GetInfo', // 메뉴,언어정보
      logout: 'api/Account/LogOut', // 로그아웃
      getLanguage: 'api/Account/GetLoginLan', // 언어 목록
      getFindId: 'api/Account/GetFindId', // ID 찾기
      getFindPw: 'api/Account/GetFindPw', // Password 찾기
      CheckUserId: 'api/Account/CheckUserId', // ID 중복 체크
      SpLoginR4: 'api/Account/SP_LOGIN_R4', // 지역별 현장 조회
      SpLoginU3: 'api/Account/SP_LOGIN_U3', // 회원가입 저장
      SpLoginR5: 'api/Account/SP_LOGIN_R5', // 사업체 조회
      ChangePassword: 'api/Account/ChangePassword', // 비밀번호 변경
      mokRequestPageUrl: 'api/mok_std_request', // MOBILEOK.process()용 이용기관 요청 페이지 경로
      updateIdentity: 'api/Account/UpdateIdentity', // 본인인증 정보 업데이트
      saveTempPassword: 'api/Account/SaveTempPassword', // 임시 비밀번호 발급
      CheckClientVersion: 'api/Account/CheckClientVersion', // 클라이언트 버전 조회(TB_VERSION)
    },
    /* 공통 유틸 */
    Utility: {
      getMember: 'api/Utility/GetMember', //
      getMenuDescription: 'api/Utility/GetMenuDescription', //메뉴 정보 조회
      getVersionLog: 'api/Utility/GetVersionLog', //버젼 로그 조회
      getDepLast: 'api/Utility/GetDepLast', //마지막 부서 조회
      getCompanyInfo: 'api/Utility/GetCompanyInfo', //회사 정보 조회
      getCustomerInfo: 'api/Utility/GetCustomerInfo', //업체 정보 조회
      getIndustryInfo: 'api/Utility/GetIndustryInfo', //업종 정보 조회
      getAuthInfo: 'api/Utility/GetAuthInfo', //권한 정보 조회
      saveActionLog: 'api/Utility/SaveActionLog', //저장 액션 로그 저장
      getCodeInfo: 'api/Utility/GetCodeInfo', //코드 정보 조회
      getSafetyManager: 'api/Utility/GetSafetyManager', //안전 관리자 정보 조회
    },
    /* 홈 */
    Home: {
      getNotice: 'api/Home/GetNotice', //공지사항 조회
      getSeriousDisaster: 'api/Home/GetSeriousDisaster', //중대재해처벌법 조회
      getNewsLetter: 'api/Home/GetNewsLetter', //안전뉴스 조회
      getHomeData: 'api/Home/GetHomeData', // 홈 통합(공지/TBM/메뉴플래그 등) — 근로자의견 기간 메뉴 분기용
      getHomeDashboradR1: 'api/Home/GetHomeDashboradR1', //홈 대시보드  조회
      getHomeDashboradR2: 'api/Home/GetHomeDashboradR2', //알람 상세 조회
      getHomeDashboradR3: 'api/Home/GetHomeDashboradR3', //업무목록 완료내역 조회
      saveHomeDashboardU1: 'api/Home/SaveHomeDashboardU1', // 업무 목록 저장
      saveHomeDashboardU2: 'api/Home/SaveHomeDashboardU2', // 업무 목록 상태 변경
      saveHomeDashboardU3: 'api/Home/SaveHomeDashboardU3', // 업무 목록 우선 순위 변경
      saveHomeDashboardU4: 'api/Home/SaveHomeDashboardU4', // 알람 확인 처리
      deleteHomeDashboardD1: 'api/Home/DeleteHomeDashboardD1', //업무 삭제
    },
    /* FTP */
    Ftp: {
      ftpRequest: 'api/Ftp/FtpRequest', //FTP 업로드
      ftpResponse: 'api/Ftp/FtpResponse', //FTP 다운로드
    },
    /* FILE 서버 */
    File: {
      videoUpload: 'api/File/VideoUpload', //파일서버 업로드
      UploadChunk: 'api/File/UploadChunk', //파일서버 대용량 업로드 - Chunk
      MergeChunks: 'api/File/MergeChunks', //파일서버 대용량 업로드 - MergeChunk
      UrlFileDownload: 'api/File/UrlFileDownload', //파일 다운로드
      DeleteFile: 'api/File/DeleteFile', //파일 삭제
      ConvertHwpToPdf: 'api/File/ConvertHwpToPdf', //한글 -> PDF 변환
      ConvertOfficeToPdf: 'api/File/ConvertOfficeToPdf', //Office파일 -> PDF 변환(한글 제외)
      moveAndReplaceFile: 'api/File/moveAndReplaceFile', //Preview 파일 이동/삭제
    },
    /* 메일 */
    SendMail: {
      sendOutlookMail: 'api/SendMail/SendOutlookMail', //RPA 메일보내기
      sendMail: 'api/SendMail/SendMail', // 메일전송
    },
    /* 회사 관리 */
    Company: {
      getComBasicR1: 'api/Company/GetComBasicR1', //회사 목록 조회
      getComBasicR2: 'api/Company/GetComBasicR2', //대표자 목록 조회
      saveComBasicU1: 'api/Company/SaveComBasicU1', //회사 목록 저장
      deleteComBasicD1: 'api/Company/DeleteComBasicD1', //회사 목록 삭제
    },
    /* 사업장 관리 */
    Plant: {
      getPlaBasicR1: 'api/Plant/GetPlaBasicR1', //업체 목록 조회
      getPlaBasicR2: 'api/Plant/GetPlaBasicR2', //관리자 조회
      getPlaBasicR3: 'api/Plant/GetPlaBasicR3', //인력 조회
      savePlaBasicU1: 'api/Plant/SavePlaBasicU1', //업체 목록 저장
      savePlaBasicU2: 'api/Plant/SavePlaBasicU2', //직인 업데이트 저장
      savePlaBasicU3: 'api/Plant/SavePlaBasicU3', //관리자 팝업 안 관리자 ID 저장
      deletePlaBasicD1: 'api/Plant/DeletePlaBasicD1', //업체 목록 삭제
    },
    /* 인력관리 */
    Member: {
      getMemBasicR1: 'api/Member/GetMemBasicR1', //인력 조회
      getMemBasicR2: 'api/Member/GetMemBasicR2', //부서 팝업창 조회
      getMemBasicR3: 'api/Member/GetMemBasicR3', //총 계약 인원후 ,멤버수 조회
      getMemBasicR4: 'api/Member/GetMemBasicR4', //직책 조회
      saveMemBasicU1: 'api/Member/SaveMemBasicU1', //인력 저장
      saveMemBasicU2: 'api/Member/SaveMemBasicU2', //인력 사용유무 N처리
      saveMemBasicU3: 'api/Member/SaveMemBasicU3', //활성화 / 비활성화
      saveMemBasicU4: 'api/Member/SaveMemBasicU4', //직책 추가
      saveMemBasicU5: 'api/Member/SaveMemBasicU5', //총괄관리자 선임
      saveMemBasicU6: 'api/Member/SaveMemBasicU6', //총괄관리자 소속 사업장 선택
      deleteMemBasicD1: 'api/Member/DeleteMemBasicD1', //인력 삭제
    },
    /* 부서관리 */
    Depart: {
      getDepBasicR1: 'api/Depart/GetDepBasicR1', //부서 목록 조회
      saveDepBasicU1: 'api/Depart/SaveDepBasicU1', //부서 목록 저장
      deleteDepBasicD1: 'api/Depart/DeleteDepBasicD1', //부서 목록 삭제
    },
    /* 공종관리 */
    Gongjong: {
      getGonBasicR1: 'api/Gongjong/GetGonBasicR1', // 공정 조회 (부서코드 기준)
      saveGonBasicU1: 'api/Gongjong/SaveGonBasicU1', // 공정 저장 (INSERT/UPDATE)
      deleteGonBasicD1: 'api/Gongjong/DeleteGonBasicD1', // 공정 삭제
    },
    /* 메뉴관리 */
    Menu: {
      getMenBasicR0MenuUp: 'api/Menu/GetMenBasicR0MenuUp', // 상위메뉴 조회
      getMenBasicR1: 'api/Menu/GetMenBasicR1', // 메뉴 조회
      getMenBasicR2: 'api/Menu/GetMenBasicR2', // 프로그램 조회
      saveMenBasicU1: 'api/Menu/SaveMenBasicU1', // 메뉴 저장
      saveMenBasicU2: 'api/Menu/SaveMenBasicU2', // 프로그램 저장
      deleteMenBasicD1: 'api/Menu/DeleteMenBasicD1', // 메뉴 삭제
      deleteMenBasicD2: 'api/Menu/DeleteMenBasicD2', // 프로그램 삭제
    },
    /* 권한 메뉴상세 (TB_BS_MENU_DTL, AuthController) */
    Auth: {
      getAutBasicR1: 'api/Auth/GetAutBasicR1', // 권한별 메뉴상세 목록
      getAutBasicR2: 'api/Auth/GetAutBasicR2', // 프로그램 목록(모달)
      saveAutBasicU1: 'api/Auth/SaveAutBasicU1', // 메뉴상세 저장
      deleteAutBasicD1: 'api/Auth/DeleteAutBasicD1', // 메뉴상세 삭제
    },
    /* 공통코드 관리 (TB_BS_CODE, CodeController) */
    Code: {
      getCodBasicR0GroupUp: 'api/Code/GetCodBasicR0GroupUp', // 그룹코드 목록
      getCodBasicR1: 'api/Code/GetCodBasicR1', // 코드 목록
      saveCodBasicU1: 'api/Code/SaveCodBasicU1', // 저장
      deleteCodBasicD1: 'api/Code/DeleteCodBasicD1', // 삭제
    },
    /* 회사별 메뉴 (CompanyMenuController) */
    CompanyMenu: {
      getCouBasicR1: 'api/CompanyMenu/GetCouBasicR1', // 회사별 메뉴 조회
      getCouBasicR2: 'api/CompanyMenu/GetCouBasicR2', // 구분(PL_TYPE) 조회
      saveCouBasicU1: 'api/CompanyMenu/SaveCouBasicU1', // 저장
      deleteCouBasicD1: 'api/CompanyMenu/DeleteCouBasicD1', // 삭제
    },
    /* 업종별 프로그램 (IndustryMenuController, TB_BS_PROGRAM_INDUSTRY) */
    IndustryMenu: {
      getIndBasicR1: 'api/IndustryMenu/GetIndBasicR1', // 구분(PL_TYPE) 목록 — TB_BS_CODE GROUP_CD=PL_TYPE
      getIndBasicR2: 'api/IndustryMenu/GetIndBasicR2', // 업종별 매핑된 프로그램 목록
      getIndBasicR3: 'api/IndustryMenu/GetIndBasicR3', // 매핑 가능 프로그램(미등록) 목록
      saveIndBasicU1: 'api/IndustryMenu/SaveIndBasicU1', // 프로그램 매핑 저장
      deleteIndBasicD1: 'api/IndustryMenu/DeleteIndBasicD1', // 프로그램 매핑 삭제
    },
    /* 데이터 이관 (DataMigrationController) */
    DataMigration: {
      copyDatBasicU1: 'api/DataMigration/CopyDatBasicU1', // 전체 페이지 일괄 이관
      copyDatBasicU2: 'api/DataMigration/CopyDatBasicU2', // 특정 페이지(ProId) 이관
      deleteDatBasicU1: 'api/DataMigration/DeleteDatBasicU1', // 예산관리(BUD_BASIC) 대상 데이터 삭제
    },

    /* 팝업 관리 (PopBasicController) */
    PopupManagement: {
      getPopBasicR1: 'api/PopBasic/GetPopBasicR1', //팝업 목록 조회
      getPopBasicR2: 'api/PopBasic/GetPopBasicR2', //대시보드 노출 팝업 조회
      getPopBasicR3: 'api/PopBasic/GetPopBasicR3', //팝업 파일 목록 조회
      savePopBasicU1: 'api/PopBasic/SavePopBasicU1', //팝업 마스터 저장
      savePopBasicU2: 'api/PopBasic/SavePopBasicU2', //팝업 파일 저장
      savePopBasicU3: 'api/PopBasic/SavePopBasicU3', //팝업 동의·오늘하루보지않기 (TB_POP_POPUP_AGREE)
      deletePopBasicD1: 'api/PopBasic/DeletePopBasicD1', //팝업 마스터 삭제
      deletePopBasicD2: 'api/PopBasic/DeletePopBasicD2', //팝업 파일 삭제
    },

    /* 공지 및 게시 */
    Notice: {
      /* 공지사항 탭 */
      getNotBasicR1: 'api/Notice/GetNotBasicR1', //공지사항 목록 조회
      getNotBasicR2: 'api/Notice/GetNotBasicR2', //공지사항 파일 조회
      getNotBasicR3: 'api/Notice/GetNotBasicR3', //공지사항 구분 상세 조회
      saveNotBasicU1: 'api/Notice/SaveNotBasicU1', //공지사항 저장
      saveNotBasicU2: 'api/Notice/SaveNotBasicU2', //공지사항 저장
      deleteNotBasicD1: 'api/Notice/DeleteNotBasicD1', //공지사항 파일삭제
      deleteNotBasicD2: 'api/Notice/DeleteNotBasicD2', //공지사항 삭제
      /* 게시 탭 */
      getNotBasic02R1: 'api/Notice/GetNotBasic02R1', //게시조회
      saveNotBasic02U1: 'api/Notice/SaveNotBasic02U1', //게시저장
      deleteNotBasic02D1: 'api/Notice/deleteNotBasic02D1', //게시삭제
    },
    /* 스케줄관리 */
    Calendar: {
      getCalendarR1: 'api/Calendar/GetCalendarR1', //내 캘린더 조회
      getCalendarR2: 'api/Calendar/GetCalendarR2', //내 캘린더 일정 조회
      getCalendarR3: 'api/Calendar/GetCalendarR3', //공유 캘린더  조회
      getCalendarR4: 'api/Calendar/GetCalendarR4', // 관심 캘린더 추가 시 관리자 조회
      getCalendarR5: 'api/Calendar/GetCalendarR5', // 공유캘린더 추가 시 공유자의 캘린더ID조회
      getCalendarR6: 'api/Calendar/GetCalendarR6', // 내일정 보고있는 사람 조회
      saveCalBasicU1: 'api/Calendar/SaveCalBasicU1', // 일정 등록
      saveCalBasicU2: 'api/Calendar/SaveCalBasicU2', // 내캘린더 , 관심캘린더 체크박스 이벤트
      saveCalBasicU3: 'api/Calendar/SaveCalBasicU3', // 내캘린더 저장/수정
      saveCalBasicU4: 'api/Calendar/SaveCalBasicU4', // 관심캘린더 저장/수정
      saveCalBasicU5: 'api/Calendar/SaveCalBasicU5', // 내일정을 보고 있는 동료 신청 수락
      deleteCalBasicD1: 'api/Calendar/DeleteCalBasicD1', // 내캘린더 삭제
      deleteCalBasicD2: 'api/Calendar/DeleteCalBasicD2', // 공유캘린더 삭제
      deleteCalBasicD3: 'api/Calendar/DeleteCalBasicD3', // 이벤트 삭제 IS_CANCELLED 플래그 Y로 변경
    },
    /* 보이스 체크 현황 */
    Aicall: {
      getAiBasic01R1: 'api/Aicall/GetAiBasic01R1', // 보이스 체크 조회
      getAiBasic01R2: 'api/Aicall/GetAiBasic01R2', // 보이스 체크 조회
      getAiBasic01R3: 'api/Aicall/GetAiBasic01R3', // 보이스 체크 조회
      getAiBasic02R1: 'api/Aicall/GetAiBasic02R1', // 보이스 체크 조회
      saveAiBasicU1: 'api/Aicall/SaveAiBasicU1', // 보이스 체크 저장
      saveAiBasicU2: 'api/Aicall/SaveAiBasicU2', // 보이스 체크 저장
      saveAiBasicU3: 'api/Aicall/SaveAiBasicU3', //  SEQ 순서 재정렬 프로시저 별도 실행
      deleteAiBasicD1: 'api/Aicall/DeleteAiBasicD1', // 보이스 체크 삭제
    },
    /* 예산관리  */
    BudgetManagement: {
      getBudBasicR1: 'api/BudBasic/GetBudBasicR1', //예산관리 기본 조회
      getBudBasicR2: 'api/BudBasic/GetBudBasicR2', //예산관리 기본02 조회
      getBudCategoryR1: 'api/BudBasic/GetBudCategoryR1', //예산 구분 조회
      getBudItemR1: 'api/BudBasic/GetBudItemR1', //예산 구분상세 조회
      getBudFileR1: 'api/BudBasic/GetBudFileR1', //예산관리 파일 조회
      saveBudBasicU1: 'api/BudBasic/SaveBudBasicU1', // 예산관리 기본 저장
      saveBudFileU1: 'api/BudBasic/SaveBudFileU1', // 예산관리 파일 저장
      saveBudCategoryU1: 'api/BudBasic/SaveBudCategoryU1', // 예산 구분 저장
      saveBudItemU1: 'api/BudBasic/SaveBudItemU1', // 예산 구분상세 저장
      deleteBudFileD1: 'api/BudBasic/DeleteBudFileD1', // 예산관리 파일 삭제
      deleteBudCategoryD1: 'api/BudBasic/DeleteBudCategoryD1', //  예산 구분 삭제
      deleteBudBasicD1: 'api/BudBasic/DeleteBudBasicD1', //  예산관리 기본 삭제
      deleteBudItemD1: 'api/BudBasic/DeleteBudItemD1', //  예산 구분상세 삭제
    },
    /* 비상대응매뉴얼  */
    EmergencyManual: {
      GetEmrBasicR1: 'api/EmrBasic/GetEmrBasicR1', //비상대응매뉴얼 기본 조회
      saveEmrBasicU1: 'api/EmrBasic/SaveEmrBasicU1', //비상대응매뉴얼 기본 저장
      deleteEmrBasicD1: 'api/EmrBasic/DeleteEmrBasicD1', // 비상대응매뉴얼 기본 삭제
    },
    /* 법규준수평가 */
    LegalCompliance: {
      getLegBasicR1: 'api/LegBasic/GetLegBasicR1', //법규준수 기본 조회
      getLegBasicR2: 'api/LegBasic/GetLegBasicR2', //법규준수 기본 상세 조회 (데이터가 없으면 템플릿 복사)
      saveLegBasicU1: 'api/LegBasic/SaveLegBasicU1', //법규준수 저장 (배열 처리)
      saveLegBasicU2: 'api/LegBasic/SaveLegBasicU2', //법규준수 일괄 업데이트 (상/하반기, 평가시간 전체 적용) (배열 처리)
      deleteLegBasicD1: 'api/LegBasic/DeleteLegBasicD1', //법규준수 일괄 삭제 (배열 처리)
      deleteLegBasicD2: 'api/LegBasic/DeleteLegBasicD2', //법규준수 단일 삭제 (배열 처리)
    },
    /* 안전보건목표 및 추진계획 */
    PolicyAndGoals: {
      getPolFileR1: 'api/PolBasic/GetPolFileR1', //안전보건목표 및 추진계획 파일 조회
      getPolBasicR1: 'api/PolBasic/GetPolBasicR1', //안전보건목표 및 추진계획 기본 조회
      getPolBasic02R1: 'api/PolBasic/GetPolBasic02R1', // 안전보건목표 및 추진계획 기본02 조회
      getPolBasic02R2: 'api/PolBasic/GetPolBasic02R2', //안전보건목표 및 추진계획 기본02 상세 조회
      getPolBasic02R3: 'api/PolBasic/GetPolBasic02R3', //안전보건목표 및 추진계획 기본02 상세 단일 조회
      getPolBasic02R4: 'api/PolBasic/GetPolBasic02R4', // 안전보건목표 및 추진계획 기본02 마스터-상세 조회
      getPolBasic02R5: 'api/PolBasic/GetPolItemR1', // 카테고리 세부목록조회
      getPolCategoryR1: 'api/PolBasic/GetPolCategoryR1', // 추진계획 구분(카테고리) 조회
      savePolFileU1: 'api/PolBasic/SavePolFileU1', //안전보건목표 및 추진계획 파일 저장
      savePolBasicU1: 'api/PolBasic/SavePolBasicU1', //안전보건목표 및 추진계획 기본 저장
      savePolBasic02U1: 'api/PolBasic/SavePolBasic02U1', //안전보건목표 및 추진계획 기본02 마스터 저장
      savePolBasic02U2: 'api/PolBasic/SavePolBasic02U2', // 안전보건목표 및 추진계획 기본02 상세 저장
      savePolBasic02U3: 'api/PolBasic/SavePolBasic02U3', //안전보건목표 및 추진계획 기본02 상세 파일 정보 업데이트
      savePolBasic02U4: 'api/PolBasic/SavePolItemU1', // 카테고리 세부 목록 저장
      savePolCategoryU1: 'api/PolBasic/SavePolCategoryU1', // 추진계획 구분(카테고리) 저장/수정
      deletePolFileD1: 'api/PolBasic/DeletePolFileD1', // 안전보건목표 및 추진계획 파일 삭제
      deletePolBasicD1: 'api/PolBasic/DeletePolBasicD1', // 안전보건목표 및 추진계획 기본 삭제
      deletePolBasic02D1: 'api/PolBasic/DeletePolBasic02D1', //안전보건목표 및 추진계획 기본02 상세 삭제
      deletePolCategoryD1: 'api/PolBasic/DeletePolCategoryD1', // 추진계획 구분(카테고리) 삭제
      deletePolBasic02D3: 'api/PolBasic/DeletePolItemD1', // 추진계획 구분(카테고리) 하위 삭제
    },
    /* 산업안전보건위원회 */
    SafetyCommittee: {
      getSacBasicR1: 'api/SacBasic/GetSacBasicR1', // 안전보건위원회 기본 조회
      getSacBasicR2: 'api/SacBasic/GetSacBasicR2', // 안전보건위원회 회원 정보 조회
      getSacBasicR3: 'api/SacBasic/GetSacBasicR3', // 안전보건위원회 회의 결과 조회
      getSacBasicR4: 'api/SacBasic/GetSacBasicR4', // 안전보건위원회 대표자 정보 조회
      getSacBasicR5: 'api/SacBasic/GetSacBasicR5', // 안전보건위원회 참석인원 조회
      saveSacBasicU1: 'api/SacBasic/SaveSacBasicU1', // 안전보건위원회 마스터 저장
      saveSacBasicU2: 'api/SacBasic/SaveSacBasicU2', //  안전보건위원회 회원 저장
      saveSacBasicU3: 'api/SacBasic/SaveSacBasicU3', //  안전보건위원회 회의안건 저장
      saveSacBasicU4: 'api/SacBasic/SaveSacBasicU4', //  안전보건위원회 상태 업데이트
      deleteSacBasicD1: 'api/SacBasic/DeleteSacBasicD1', //  안전보건위원회 삭제
      deleteSacBasicD2: 'api/SacBasic/DeleteSacBasicD2', //  안전보건위원회 회원 삭제 (참석자 등록 시 기존 데이터 삭제 후 재 인서트하기 위함)
      deleteSacBasicD3: 'api/SacBasic/DeleteSacBasicD3', //  안전보건위원회 회의 결과 삭제
    },
    /* 안전보건인력 */
    SafetyPersonnel: {
      getSapBasic01R1: 'api/SapBasic/GetSapBasic01R1', //조직도 조회 기본 조회
      getSapBasic01R2: 'api/SapBasic/GetSapBasic01R2', //조직도 구성원 조회
      getSapBasic01R3: 'api/SapBasic/GetSapBasic01R3', //조직도 부서 조회
      getSapBasic02R1: 'api/SapBasic/GetSapBasic02R1', //안전보건인력 기본 조회
      getSapBasic02R2: 'api/SapBasic/GetSapBasic02R2', //안전보건인력 평가표 조회
      getSapBasic02R3: 'api/SapBasic/GetSapBasic02R3', //안전보건인력 평가표 조회
      saveSapBasic01U1: 'api/SapBasic/SaveSapBasic01U1', //조직도 저장
      saveSapBasic02U1: 'api/SapBasic/SaveSapBasic02U1', //안전보건인력 저장
      saveSapBasic02U2: 'api/SapBasic/SaveSapBasic02U2', //안전보건인력 평가표 저장
      deleteSapBasic02D1: 'api/SapBasic/DeleteSapBasic02D1', //안전보건인력 평가표 삭제
    },
    /* 중대재해처벌법 이행관리 */
    SeriousAccidentAct: {
      getSerBasicR1: 'api/SerBasic/GetSerBasicR1', //중대재해처벌법 기본 조회
      getSerBasicR2: 'api/SerBasic/GetSerBasicR2', // 중대재해처벌법 사이트 정보 조회
      getSerBasic01R1: 'api/SerBasic/GetSerBasic01R1', //중대재해처벌법 마스터 상세 조회
      getSerBasic01R2: 'api/SerBasic/GetSerBasic01R2', //중대재해처벌법 상세 정보 조회
      saveSerBasic01U1: 'api/SerBasic/SaveSerBasic01U1', //중대재해처벌법 마스터 저장
      saveSerBasic01U2: 'api/SerBasic/SaveSerBasic01U2', //중대재해처벌법 상세 정보 저장
      saveSerBasic01U3: 'api/SerBasic/SaveSerBasic01U3', //중대재해처벌법 총취득점수 저장
      deleteSerBasicD1: 'api/SerBasic/DeleteSerBasicD1', //중대재해처벌법 평가 삭제
    },
    /* 도급사업관리 */
    SubcontractorManagement: {
      getSubBasic01R1: 'api/SubBasic/GetSubBasic01R1', //수급업체 기본 조회
      getSubBasic01MstR1: 'api/SubBasic/GetSubBasic01MstR1', //수급 평가표 목록 조회
      getSubBasicMst01R2: 'api/SubBasic/GetSubBasicMst01R2', //수급 평가표 상세 조회
      getSubBasicMst02R1: 'api/SubBasic/GetSubBasicMst02R1', //수급 평가표 조회
      getSubBasicMst02R2: 'api/SubBasic/GetSubBasicMst02R2', //수급 평가표 조회 R2
      getSubBasicMst03R1: 'api/SubBasic/GetSubBasicMst03R1', //수급 회의록 조회
      getSubBasicMst03R2: 'api/SubBasic/GetSubBasicMst03R2', //수급 회의록 결과 조회
      getSubBasicMst03R3: 'api/SubBasic/GetSubBasicMst03R3', //수급 회의록 상세 조회
      getSubBasicMst03R4: 'api/SubBasic/GetSubBasicMst03R4', //수급 회의록 대표자 정보 조회
      saveSubBasic01U1: 'api/SubBasic/SaveSubBasic01U1', //수급업체 저장
      saveSubBasic01MstU1: 'api/SubBasic/SaveSubBasic01MstU1', //수급 평가표 저장
      saveSubBasic03U1: 'api/SubBasic/SaveSubBasic03U1', //수급 회의록 저장
      saveSubBasic03U2: 'api/SubBasic/SaveSubBasic03U2', //수급 회의록 참석자 저장
      saveSubBasic03U3: 'api/SubBasic/SaveSubBasic03U3', //수급 회의록 결과 저장
      saveSubBasic03U4: 'api/SubBasic/SaveSubBasic03U4', //수급 회의록 상태 저장
      deleteSubBasic01D1: 'api/SubBasic/DeleteSubBasic01D1', //수급업체 삭제
      deleteSubBasic01MstD1: 'api/SubBasic/DeleteSubBasic01MstD1', //수급 평가표 삭제
      deleteSubBasic03D1: 'api/SubBasic/DeleteSubBasic03D1', //수급 회의록 삭제
      deleteSubBasic03D2: 'api/SubBasic/DeleteSubBasic03D2', //수급 회의록 결과 삭제
      deleteSubBasic03D3: 'api/SubBasic/DeleteSubBasic03D3', //수급 회의록 참석자 삭제
    },
    /* 위험성평가 */
    RiskEvaluation: {
      getRisBasic01R1: 'api/RisBasic/GetRisBasic01R1', //위험성평가 조회
      getRisBasic01R2: 'api/RisBasic/GetRisBasic01R2', //위험성평가 상세 조회
      getRisBasic01R3: 'api/RisBasic/GetRisBasic01R3', //위험성평가 부서별 공정 조회
      getRisBasic01R4: 'api/RisBasic/GetRisBasic01R4', //유해·위험 기계·기구 통합 조회
      getRisBasic01R5: 'api/RisBasic/GetRisBasic01R5', //위험성평가 실시 안 작업목록 조회
      getRisBasic01R6: 'api/RisBasic/GetRisBasic01R6', //위험성평가 실시 안 표준모델 조회
      getRisBasic02R1: 'api/RisBasic/GetRisBasic02R1', //위험성평가 결과서 조회
      getRisBasic02R2: 'api/RisBasic/GetRisBasic02R2', //위험성평가 체크리스트 조회
      saveRisBasic01U1: 'api/RisBasic/SaveRisBasic01U1', //위험성평가 저장
      saveRisBasic01U2: 'api/RisBasic/SaveRisBasic01U2', //위험성평가 안 공정등록 저장
      saveRisBasic01U3: 'api/RisBasic/SaveRisBasic01U3', //위험성평가 실시 저장
      saveRisBasic02U1: 'api/RisBasic/SaveRisBasic02U1', //위험성평가 결과표 저장
      saveRisBasic02U2: 'api/RisBasic/SaveRisBasic02U2', //위험성평가 체크리스트 저장
      deleteRisBasic01D1: 'api/RisBasic/DeleteRisBasic01D1', //위험성평가 안 공정등록 저장
      // RIS_BASIC_CUSTOM
      getRisCustomR1: 'api/RisCustom/GetRisCustomR1', //위험성평가 커스텀 조회(년도 기준)
      saveRisCustomU1: 'api/RisCustom/SaveRisCustomU1', //기본정보 저장(커스텀)
      saveRisCustomU2: 'api/RisCustom/SaveRisCustomU2', //실시규정 저장(등록/해제)
      deleteRisCustomD1: 'api/RisCustom/DeleteRisCustomD1', //위험성평가 커스텀 마스터 삭제(RS_CD)
      getRisCustom00R1: 'api/RisCustom/GetRisCustom00R1', //위험성평가 대기 대시보드(진행단계+활동로그+진행률, RS_CD)
      getRisCustom00R2: 'api/RisCustom/GetRisCustom00R2', //위험성평가 최근 활동내역(RS_CD)
      getRisCustom01R1: 'api/RisCustom/GetRisCustom01R1', //안전보건정보 단계 조회(예정)
      getRisCustom01R4: 'api/RisCustom/GetRisCustom01R4', // 공정·설비·물질 + 실시상세 통합 조회
      getRisCustom01R2: 'api/RisCustom/GetRisCustom01R2', //안전보건정보 공정모달: 부서+공정 통합 조회
      getRisCustom01R3: 'api/RisCustom/GetRisCustom01R3', //안전보건정보 설비·물질 통합 조회(유해·위험 기계·기구 통합 조회)
      saveRisCustom01U1: 'api/RisCustom/SaveRisCustom01U1', //안전보건정보 공정등록 저장
      saveRisCustom01U2: 'api/RisCustom/SaveRisCustom01U2', //안전보건정보 공정/설비/물질 저장
      saveRisCustom01U3: 'api/RisCustom/SaveRisCustom01U3', //안전보건정보 기타(수기) 설비 등록·수정 TB_BO_HAZ_BASIC_04
      deleteRisCustom01D3: 'api/RisCustom/DeleteRisCustom01D3', //안전보건정보 기타(수기) 설비 삭제 TB_BO_HAZ_BASIC_04
      saveRisCustom01U4: 'api/RisCustom/SaveRisCustom01U4', //안전보건정보 기타(수기) 물질 등록·수정 TB_BO_HAM_BASIC_04
      deleteRisCustom01D4: 'api/RisCustom/DeleteRisCustom01D4', //안전보건정보 기타(수기) 물질 삭제 TB_BO_HAM_BASIC_04
      getRisCustom02R1: 'api/RisCustom/GetRisCustom02R1', //위험성평가 실시 조회
      saveRisCustom02U1: 'api/RisCustom/SaveRisCustom02U1', //위험성평가 실시 저장
      saveRisCustom02U2: 'api/RisCustom/SaveRisCustom02U2', //위험성평가 근로자 의견받기 기간(TB_BS_CUST)
      deleteRisCustom02D1: 'api/RisCustom/DeleteRisCustom02D1', //위험성평가 실시 삭제
      saveRisCustom03U1: 'api/RisCustom/SaveRisCustom03U1', //개선보고서 단계 진행(TB_SF_RISK_PROGRESS)
    },
    External: {
      syncRiskLibraryOnly: 'api/KoshaRisk/SyncRiskLibraryOnly',
      syncRiskLibraryOnlyByIndCd: 'api/KoshaRisk/SyncRiskLibraryOnlyByIndCd',
      /** 업종정보코드(산재업종-대중소/표준산업-대중소) */
      fetchKoshaIndustryCodes: 'api/KoshaRisk/FetchKoshaIndustryCodes',
      /** 단일 버튼 — 공정·평가키·위험요인·위험등급·(옵션)조치까지 한 번에 (POST, timeout 넉넉히) */
      syncFullKoshaData: 'api/KoshaRisk/SyncFullKoshaData',
      syncFullKoshaDataByIndCd: 'api/KoshaRisk/SyncFullKoshaDataByIndCd',
      /** 관리/배치용 일괄 (POST) */
      syncAllRiskDetail: 'api/KoshaRisk/SyncAllRiskDetail',
      syncAllRiskLevel: 'api/KoshaRisk/SyncAllRiskLevel',
      syncAllHealthMeasures: 'api/KoshaRisk/SyncAllHealthMeasures',
      /** 포털 업종 병합(selectIndustryPopList) 후 전체 업종 라이브러리 순회 (POST, 장시간) */
      syncAllIndustryPipeline: 'api/KoshaRisk/SyncAllIndustryPipeline',
      /** 전 업종 공정 라이브러리만 — indCd/koshaCd 입력 불필요 (POST, syncDetail false) */
      syncAllRiskLibraryOnly: 'api/KoshaRisk/SyncAllRiskLibraryOnly',
      /** 포털 병합 후 전 업종 라이브러리만 (POST) */
      syncAllIndustryPipelineRiskLibraryOnly:
        'api/KoshaRisk/SyncAllIndustryPipelineRiskLibraryOnly',
      syncAllRiskData: 'api/KoshaRisk/SyncAll',
      /** 상세 1건만 위험등급 재동기화 (POST ?riskDtlId=) */
      syncRiskLevelForRiskDtl: 'api/KoshaRisk/SyncRiskLevelForRiskDtl',
      syncPendingRiskData: 'api/KoshaRisk/SyncPending',
    },
    /* 안전작업 관리 (Basic) - Custom이랑 완전 동일한 구조지만 추후 유지보수용이성을 위해 분리시킴*/
    SafeWorkProcedure: {
      getSafBasic01R1: 'api/SafBasic/GetSafBasic01R1', //작업계획서 기본 조회
      saveSafBasic01U1: 'api/SafBasic/SaveSafBasic01U1', //작업계획서 기본 저장
      deleteSafBasic01D1: 'api/SafBasic/DeleteSafBasic01D1', //작업계획서 기본 삭제
      getSafBasic02R1: 'api/SafBasic/GetSafBasic02R1', //안전작업허가서 조회
      getSafBasic02R2: 'api/SafBasic/GetSafBasic02R2', // 안전작업허가서 상세 조회
      getSafBasic02R3: 'api/SafBasic/GetSafBasic02R3', // 안전작업허가서 반려이력조회
      saveSafBasic02U2: 'api/SafBasic/SaveSafBasic02U2', //안전작업허가서 반려/승인 저장
      deleteSafBasic02D1: 'api/SafBasic/DeleteSafBasic02D1', //안전작업허가서 삭제
    },

    /* 안전작업 관리(작업종류별)(Custom) - 코드추가기능 추가된 버전 */
    SafetyWorkManagement: {
      getSamBasic01R1: 'api/SamBasic/GetSamBasic01R1', //작업계획서 기본 조회
      saveSamBasic01U1: 'api/SamBasic/SaveSamBasic01U1', //작업계획서 기본 저장
      deleteSamBasic01D1: 'api/SamBasic/DeleteSamBasic01D1', //작업계획서 기본 삭제
      getSamBasic02R1: 'api/SamBasic/GetSamBasic02R1', //안전작업허가서 조회(구)
      getSamBasic02R4: 'api/SamBasic/GetSamBasic02R4', // 안전작업허가서 목록 조회
      getSamBasic02R2: 'api/SamBasic/GetSamBasic02R2', // 안전작업허가서 상세 조회(구 TB_BO_PERMIT)
      /** [FromQuery] PmCd, WorkDate, UserId (AES) — Mst/Dailies/DailiesByPmCd/CenterSigns/Items */
      getSamBasic02R5: 'api/SamBasic/GetSamBasic02R5',
      /** [FromQuery] custCd (AES) — 작업종·위험/보호구/준비 마스터(레포트 슬롯) */
      getSamBasic02R2Catalog: 'api/SamBasic/GetSamBasic02R2Catalog',
      getSamBasic02R3: 'api/SamBasic/GetSamBasic02R3', // 안전작업허가서 반려이력조회
      /** GUBUN 0 반려 / 1 중간결재(센터) / 2 최종(SM) — [FromBody] List */
      saveSamBasic02U2: 'api/SamBasic/SaveSamBasic02U2',
      /** 연장 승인/반려 (DETAIL EXT_*) */
      saveSamBasic02U6: 'api/SamBasic/SaveSamBasic02U6',
      /** PM_CD 기준 허가서 전체 삭제 — [FromBody] List */
      deleteSamBasic02D1: 'api/SamBasic/DeleteSamBasic02D1',
      /** DTL_CD 기준 상세 1건 삭제 — [FromBody] */
      deleteSamBasic02D2: 'api/SamBasic/DeleteSamBasic02D2',
      getSamBasic02WorkTypeItemR1: 'api/SamBasic/GetSamBasic02WorkTypeItemR1', // 코드추가기능 - 작업종류별 항목 조회
      saveSamBasic02WorkTypeItemU1: 'api/SamBasic/SaveSamBasic02WorkTypeItemU1', // 코드추가기능 - 작업종류별 항목 저장
      getSamBasic02WorkTypeCustR1: 'api/SamBasic/GetSamBasic02WorkTypeCustR1', // 사업장별 커스텀 작업종류 조회
      saveSamBasic02WorkTypeCustU1: 'api/SamBasic/SaveSamBasic02WorkTypeCustU1', // 사업장별 커스텀 작업종류 등록
      deleteSamBasic02WorkTypeCustD1: 'api/SamBasic/DeleteSamBasic02WorkTypeCustD1', // 사업장별 커스텀 작업종류 삭제
    },
    /* 유해위험기계기구 */
    HazardousMachines: {
      // HAZ_BASIC_01
      getHazBasic01R0: 'api/HazBasic/GetHazBasic01R0', //유해위험기계기구 토글 상태 조회
      getHazBasic01R1: 'api/HazBasic/GetHazBasic01R1', //유해위험기계기구 탭 데이터 조회
      getHazBasic01R2: 'api/HazBasic/GetHazBasic01R2', //유해위험기계기구 기본 조회
      saveHazBasic01U0: 'api/HazBasic/SaveHazBasic01U0', //유해위험기계기구 토글 상태 저장
      saveHazBasic01U1: 'api/HazBasic/SaveHazBasic01U1', //유해위험기계기구 기본 저장
      saveHazBasic01U4: 'api/HazBasic/SaveHazBasic01U4', //유해위험기계기구 알람 저장
      deleteHazBasic01D1: 'api/HazBasic/DeleteHazBasic01D1', //유해위험기계기구 삭제
      // HAZ_BASIC_02
      getHazBasic02R0: 'api/HazBasic/GetHazBasic02R0', //유해위험기계기구(작업별) 토글 상태 조회
      getHazBasic02R1: 'api/HazBasic/GetHazBasic02R1', //유해위험기계기구(작업별) 탭 데이터 조회
      getHazBasic02R2: 'api/HazBasic/GetHazBasic02R2', //유해위험기계기구(작업별) 기본 조회
      saveHazBasic02U0: 'api/HazBasic/SaveHazBasic02U0', //유해위험기계기구(작업별) 토글 상태 저장
      saveHazBasic02U1: 'api/HazBasic/SaveHazBasic02U1', //유해위험기계기구(작업별) 기본 저장
      deleteHazBasic02D1: 'api/HazBasic/DeleteHazBasic02D1', //유해위험기계기구(작업별) 삭제
      // HAZ_BASIC_03
      getHazBasic03R1: 'api/HazBasic/GetHazBasic03R1', //유해위험기계기구(점검) 기본 조회
      saveHazBasic03U1: 'api/HazBasic/SaveHazBasic03U1', //유해위험기계기구(점검) 기본 저장
      saveHazBasic03U3: 'api/HazBasic/SaveHazBasic03U3', //유해위험기계기구(점검) 알람 저장
      deleteHazBasic03D1: 'api/HazBasic/DeleteHazBasic03D1', //유해위험기계기구(점검) 삭제
    },
    /* 유해위험물질 */
    HazardousMaterials: {
      // HAM_BASIC_01
      getHamBasic01R1: 'api/HamBasic/GetHamBasic01R1', //유해위험물질 기본 조회
      saveHamBasic01U1: 'api/HamBasic/SaveHamBasic01U1', //유해위험물질 저장
      deleteHamBasic01D1: 'api/HamBasic/DeleteHamBasic01D1', //유해위험물질 삭제
      // HAM_BASIC_02
      getHamBasic02R1: 'api/HamBasic/GetHamBasic02R1', //MSDS 관리대장 조회
      saveHamBasic02U1: 'api/HamBasic/SaveHamBasic02U1', //MSDS 관리대장 Master 저장
      saveHamBasic02U2: 'api/HamBasic/SaveHamBasic02U2', //MSDS 관리대장 Detail 저장
      saveHamBasic02U3: 'api/HamBasic/SaveHamBasic02U3', //MSDS 관리대장 파일 저장
      deleteHamBasic02D1: 'api/HamBasic/DeleteHamBasic02D1', //MSDS 관리대장 Master 삭제
      deleteHamBasic02D2: 'api/HamBasic/DeleteHamBasic02D2', //MSDS 관리대장 Detail 삭제
    },

    /* 안전보건교육 */
    Training: {
      getTraNew01R1: 'api/TraNew/GetTraNew01R1', // 교육현황 조회
      getTraNew01R2: 'api/TraNew/GetTraNew01R2', // 참석자 조회
      getTraCustom01R1: 'api/TraCustom/GetTraCustom01R1', // 교육현황 조회
      getTraCustom01R2: 'api/TraCustom/GetTraCustom01R2', // 참석자 조회
      getTraCustom05R1: 'api/TraCustom/GetTraCustom05R1', // TBM 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R1
      getTraCustom05R2: 'api/TraCustom/GetTraCustom05R2', // TBM 참석자 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R2
      saveTraCustom05U1: 'api/TraCustom/SaveTraCustom05U1', // tra_custom_05 TBM 에서 사용 중  * 기존 프로시저 : SP_TRA_BASIC_01_U1
      deleteTraCustom05D1: 'api/TraCustom/DeleteTraCustom05D1', // tra_custom_05 TBM 에서 사용 중 * 기존 프로시저 : SP_TBM_D1
      getTraNew05R1: 'api/TraNew/GetTraNew05R1', // TBM 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R1
      getTraNew05R2: 'api/TraNew/GetTraNew05R2', // TBM 참석자 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R2
      saveTraNew05U1: 'api/TraNew/SaveTraNew05U1', // tra_custom_05 TBM 에서 사용 중  * 기존 프로시저 : SP_TRA_BASIC_01_U1
      deleteTraNew05D1: 'api/TraNew/DeleteTraNew05D1', // tra_custom_05 TBM 에서 사용 중 * 기존 프로시저 : SP_TBM_D1
      getTraCustom02R1: 'api/TraCustom/GetTraCustom02R1', // 교육일지 조회
      getTraCustom02R2: 'api/TraCustom/GetTraCustom02R2', // 참석자 조회
      getTraCustom02R3: 'api/TraCustom/GetTraCustom02R3', // 참석인원 조회
      saveTraCustom02U1: 'api/TraCustom/SaveTraCustom02U1', // 교육일지 저장
      saveTraCustom02U2: 'api/TraCustom/SaveTraCustom02U2', // 교육일지 참석자 명단 저장
      saveTraCustom02Approval: 'api/TraCustom/SaveTraCustom02Approval', // 결재 상신 처리
      saveTraCustom02ApproverSign: 'api/TraCustom/SaveTraCustom02ApproverSign', // 중간/최종 결재자 서명
      saveTraCustom02ApproverReject:
        'api/TraCustom/SaveTraCustom02ApproverReject', // 중간/최종 결재자 반려
      getTraCustom02ApprovalStatus:
        'api/TraCustom/GetTraCustom02ApprovalStatus', // 결재 서명 현황 조회
      getTraCustom02ReturnHistory: 'api/TraCustom/GetTraCustom02ReturnHistory', // 반려 이력 조회
      deleteTraCustom02D1: 'api/TraCustom/DeleteTraCustom02D1', // 교육일지 삭제
      deleteTraCustom02D2: 'api/TraCustom/DeleteTraCustom02D2', // 교육일지 참석자 명단 삭제
      /** QR 임시 세션 (저장 전 참석 수집) — 최소 API */
      createTraCustom02QrSession: 'api/TraCustom/CreateTraCustom02QrSession',
      getTraCustom02SessionR2: 'api/TraCustom/GetTraCustom02SessionR2',
      bindTraCustom02QrSession: 'api/TraCustom/BindTraCustom02QrSession',
      saveTraCustom02SessionSign: 'api/TraCustom/SaveTraCustom02SessionSign', // 모바일·JWT 없음
      // 교육자료 탭
      getTraCustom04R1: 'api/TraCustom/GetTraCustom04R1', // 교육일지 조회
      getTraCustom04R2: 'api/TraCustom/GetTraCustom04R2', // 참석자 조회
      getTraCustom04R3: 'api/TraCustom/GetTraCustom04R3', // 본부 조회 * 기존 프로시저 : SP_TRA_BASIC_04_R3
      getTraCustom04R4: 'api/TraCustom/GetTraCustom04R4', // 참석인원 조회
      saveTraCustom04U1: 'api/TraCustom/SaveTraCustom04U1', // 교육일지 저장
      saveTraCustom04U2: 'api/TraCustom/SaveTraCustom04U2', // 교육일지 참석자 명단 저장
      deleteTraCustom04D1: 'api/TraCustom/DeleteTraCustom04D1', // 교육일지 삭제
      deleteTraCustom04D2: 'api/TraCustom/DeleteTraCustom04D2', // 교육일지 참석자 명단 삭제
    },
    /* 안전보건교육 */
    SafetyHealthTraining: {
      getSatBasic03R1: 'api/SatBasic/GetSatBasic03R1', // 연간교육계획표 조회
      saveSatBasic03U1: 'api/SatBasic/SaveSatBasic03U1', // 연간교육계획표 저장
      deleteSatBasic03D1: 'api/SatBasic/DeleteSatBasic03D1', // 연간교육계획표 삭제
      getSatBasic05R1: 'api/SatBasic/GetSatBasic05R1', // 교육이수현황 조회
      getSatBasic05R2: 'api/SatBasic/GetSatBasic05R2', // 교육이수현황 조회
      saveSatBasic05U1: 'api/SatBasic/SaveSatBasic05U1', // 교육이수현황 저장
      saveSatBasic05U2: 'api/SatBasic/SaveSatBasic05U2', // 교육이수현황 저장
      deleteSatBasic05D1: 'api/SatBasic/DeleteSatBasic05D1', // 교육이수현황 삭제
      deleteSatBasic05D2: 'api/SatBasic/DeleteSatBasic05D2', // 교육이수현황 삭제
      getSatBasic07R1: 'api/SatBasic/GetSatBasic07R1', // 교육관리(대상자별) 조회
      getSatBasic07R2: 'api/SatBasic/GetSatBasic07R2', // 교육관리(대상자별) 조회
      SaveSatBasic07U1: 'api/SatBasic/SaveSatBasic07U1', // 교육관리(대상자별) 저장
    },
    /* 일반건강진단 */
    HealthCheckup: {
      getHeaBasic01R1: 'api/HeaBasic/GetHeaBasic01R1', //일반건강진단 기본 조회
      saveHeaBasic01U1: 'api/HeaBasic/SaveHeaBasic01U1', //일반건강진단 저장
      saveHeaBasic01U2: 'api/HeaBasic/SaveHeaBasic01U2', //일반건강진단 알람 처리
      deleteHeaBasic01D1: 'api/HeaBasic/DeleteHeaBasic01D1', //일반건강진단 삭제
      getHeaBasic02R1: 'api/HeaBasic/GetHeaBasic02R1', //특수건강진단 기본 조회
      saveHeaBasic02U1: 'api/HeaBasic/SaveHeaBasic02U1', //특수건강진단 저장
      deleteHeaBasic02D1: 'api/HeaBasic/DeleteHeaBasic02D1', //특수건강진단 삭제
    },

    WorkEnvironment: {
      /* 작업환경측정 */
      getWorBasicR2: 'api/WorBasic/GetWorBasicR2', //작업환경측정 기본조회
      saveWorBasicU2: 'api/WorBasic/SaveWorBasicU2', //측정주기 저장 TB_BS_MEASURE_CYCLE
      /* 대상물질 */
      getWorBasic02R1: 'api/WorBasic/GetWorBasic02R1', //대상물질 기본조회
      getWorBasic02R2: 'api/WorBasic/GetWorBasic02R2', //화학물질 노출기준 목록 조회 (팝업용)
      getWorBasic02R3: 'api/WorBasic/GetWorBasic02R3', //대상물질-공정 인쇄용 조회 (MatSeq, KorNm, GongjongNm, CheckYn)
      saveWorBasic02U1: 'api/WorBasic/SaveWorBasic02U1', //대상물질-공정 매핑 저장
      deleteWorBasic02D1: 'api/WorBasic/DeleteWorBasic02D1', //대상물질 삭제

      //옛날코드 사용하지 않음
      getWorBasic01R1: 'api/WorBasic/GetWorBasic01R1', //작업환경측정 기본 조회
      saveWorBasic01U1: 'api/WorBasic/SaveWorBasic01U1', //작업환경측정 저장
      deleteWorBasic01D1: 'api/WorBasic/DeleteWorBasic01D1', //작업환경측정 삭제
    },
    /* 보호구관리 */
    PPEManagement: {
      // 보호구등록 (탭 1)
      getPpeBasic01R1: 'api/PpeBasic/GetPpeBasic01R1', //보호구등록 조회
      savePpeBasic01U1: 'api/PpeBasic/SavePpeBasic01U1', //보호구등록 저장
      deletePpeBasic01D1: 'api/PpeBasic/DeletePpeBasic01D1', //보호구등록 삭제
      // 보호구관리대장 (탭 2)
      getPpeBasic02R1: 'api/PpeBasic/GetPpeBasic02R1', //보호구관리대장 조회
      savePpeBasic02U1: 'api/PpeBasic/SavePpeBasic02U1', //보호구관리대장 저장
      // 보호구지급대장 (탭 3)
      getPpeBasic03R1: 'api/PpeBasic/GetPpeBasic03R1', //보호구지급대장 조회
      saveEicBasicU1: 'api/EicBasic/SaveEicBasicU1', // 근로자별 보호구 저장 SP_EQUIP_ISSUE_U1
      deletePpeBasic03D1: 'api/PpeBasic/DeletePpeBasic03D1', //보호구지급대장 삭제
      // 보호구기록 (탭 4)
      getPpeBasic04R1: 'api/PpeBasic/GetPpeBasic04R1', //보호구기록 조회
    },
    /* 산업재해 보고 및 기록 */
    AccidentReport: {
      getAccBasicR1: 'api/AccBasic/GetAccBasicR1', //산업재해 보고 및 기록 기본 조회
      saveAccBasicU1: 'api/AccBasic/SaveAccBasicU1', //산업재해 보고 및 기록 저장
      deleteAccBasicD1: 'api/AccBasic/DeleteAccBasicD1', //산업재해 보고 및 기록 삭제
    },
    /* 재해현황 (산업재해현황, 아차사고현황, 통계) */
    AccidentStatus: {
      getAccBasic01R1: 'api/AccBasic/GetAccBasic01R1', //산업재해현황 조회
      saveAccBasic01U1: 'api/AccBasic/SaveAccBasic01U1', //산업재해현황 저장
      deleteAccBasic01D1: 'api/AccBasic/DeleteAccBasic01D1', //산업재해현황 삭제
      getAccBasic02R1: 'api/AccBasic/GetAccBasic02R1', //아차사고현황 조회
      saveAccBasic02U1: 'api/AccBasic/SaveAccBasic02U1', //아차사고현황 저장
      deleteAccBasic02D1: 'api/AccBasic/DeleteAccBasic02D1', //아차사고현황 삭제
      getAccBasic03R1: 'api/AccBasic/GetAccBasic03R1', //통계 조회
      getAccBasic04R1: 'api/AccBasic/GetAccBasic04R1', //재해율 조회 (상시근로자수, 재해건수, 재해율%)
    },
    /* 근로자의견청취 - 위험성평가하기 (RIN_BASIC) — API는 재해현황 아차사고(AccBasic02)와 동일 */
    RiskNearMiss: {
      getRinBasicR1: 'api/AccBasic/GetAccBasic02R1',
      saveRinBasicU1: 'api/AccBasic/SaveAccBasic02U1',
      deleteRinBasicD1: 'api/AccBasic/DeleteAccBasic02D1',
    },
    /* 안전보건제안 — 조회/저장은 재해현황 아차사고(AccBasic02)와 동일 API (클라이언트는 주로 AccidentStatus URL 직접 사용) */
    SuggestionList: {
      getSugBasicR1: 'api/AccBasic/GetAccBasic02R1',
      getSugBasicR2: 'api/SugBasic/GetSugBasicR2', // 레거시 이미지 전용(미사용 시 유지)
      saveSugBasicU1: 'api/AccBasic/SaveAccBasic02U1',
    },
    /* 고객사 전용 헬프데스크 (1:1 문의 게시판) */
    HelpDesk: {
      getHelBasicR1: 'api/HelBasic/GetHelBasicR1',
      getHelBasicR2: 'api/HelBasic/GetHelBasicR2',
      getHelBasicR3: 'api/HelBasic/GetHelBasicR3',
      saveHelBasicU1: 'api/HelBasic/SaveHelBasicU1',
      saveHelBasicU2: 'api/HelBasic/SaveHelBasicU2',
      saveHelBasicU3: 'api/HelBasic/SaveHelBasicU3',
      deleteHelBasicD1: 'api/HelBasic/DeleteHelBasicD1',
    },
    /* 대시보드 */
    Dashboard: {
      getMaiBasicR1: 'api/MaiBasic/GetMaiBasicR1', // 메인 대시보드 조회
      getMaiBasicR2: 'api/MaiBasic/GetMaiBasicR2', // 계약 및 리스크 관리 조회
      getMaiBasicR3: 'api/MaiBasic/GetMaiBasicR3', // 회사 상세정보
      saveMaiBasicU1: 'api/MaiBasic/SaveMaiBasicU1', // 새로운 계약 저장
      /** 요구사항(REV) 보드 */
      getRevBasicR1: 'api/RevBasic/GetRevBasicR1', // 회사별 요구사항 배지 집계
      getRevBasicR2: 'api/RevBasic/GetRevBasicR2', // 요구사항 목록
      getRevBasicR3: 'api/RevBasic/GetRevBasicR3', // 요구사항 상세
      getRevBasicR4: 'api/RevBasic/GetRevBasicR4', // 담당자 후보(TB_BS_CODE REVISION_MEMBER)
      saveRevBasicU1: 'api/RevBasic/SaveRevBasicU1', // 요구사항 신규/수정
      saveRevBasicFileU2: 'api/RevBasic/SaveRevBasicFileU2', // 요구사항 첨부파일 저장
      saveRevBasicActivityU3: 'api/RevBasic/SaveRevBasicActivityU3', // 요구사항 활동(댓글) 등록
      deleteRevBasicActivityD1: 'api/RevBasic/DeleteRevBasicActivityD1', // 요구사항 활동(댓글) 삭제(본인만)
      deleteRevBasicFileD1: 'api/RevBasic/DeleteRevBasicFileD1', // 요구사항 첨부파일 단건 삭제
      deleteRevBasicD1: 'api/RevBasic/DeleteRevBasicD1', // 요구사항 삭제
    },
    Execute: {
      execute: 'api/Execute/ExecuteProcedure', //프로시저 호출
      saveActionLog: 'api/Execute/SaveActionLog', //로그 저장
      ftpRequest: 'api/Execute/FtpRequest', //FTP 업로드
      ftpResponse: 'api/Execute/FtpResponse', //FTP 다운로드
      videoUpload: 'api/Execute/VideoUpload', //파일서버 업로드
      UploadChunk: 'api/Execute/UploadChunk', //파일서버 대용량 업로드 - Chunk
      MergeChunks: 'api/Execute/MergeChunks', //파일서버 대용량 업로드 - MergeChunk
      UrlFileDownload: 'api/Execute/UrlFileDownload', //파일 다운로드
      DeleteFile: 'api/Execute/DeleteFile', //파일 삭제
      ConvertHwpToPdf: 'api/Execute/ConvertHwpToPdf', //한글 -> PDF 변환
      ConvertOfficeToPdf: 'api/Execute/ConvertOfficeToPdf', //Office파일 -> PDF 변환(한글 제외)
      moveAndReplaceFile: 'api/Execute/moveAndReplaceFile', //Preview 파일 이동/삭제
      sendOutlookMail: 'api/Execute/SendOutlookMail', //RPA 메일보내기
      sendMail: 'api/Execute/SendMail', // 메일전송
    },
    /* FCM */
    FCM: {
      fcm: 'api/Fcm/PostFcmServer', //FCM 서버 호출 (컨트롤러명 Fcm과 대소문자 일치)
    },
    /* 카카오 알림톡 (NHN Cloud) */
    Alimtalk: {
      signRequest: 'api/Alimtalk/PostSignRequestAlimtalk',
      alimtalk: 'api/Alimtalk/PostAlimtalkServer',
    },
    /* 레포트 */
    Reports: {
      reports: 'api/Reports/GetReports', //report 호출
      businessDown: 'api/Reports/GetFile',
    },
  },
};
